import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarSurfaceStore, SurfaceDragDropConfig } from 'owa-calendar-surface-dategrid';

/**
 * Checks whether the given item can be resized
 * @param store The calendar surface store
 * @param dragDropConfig The drag and drop config
 * @param item The surface item
 * @returns true if the item can be resized, false otherwise
 */
export default function canResizeItem(
    store: CalendarSurfaceStore,
    dragDropConfig: SurfaceDragDropConfig,
    item: CalendarEvent
): boolean {
    return dragDropConfig && dragDropConfig.canDrag(item);
}
